import "./NotFoundSection.scss"

const NotFoundComponent = ({message }) => {
  return (
  <>
    <section className="not-found d-flex align-items-center justify-content-center flex-wrap gap-5">
      <div className="not-found-img">
        <svg
          width="403"
          height="300"
          viewBox="0 0 403 300"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M402.624 263.637H0V263.836H402.624V263.637Z"
            fill="#EBEBEB"
          />
          <path
            d="M362.278 276.594H335.609V276.793H362.278V276.594Z"
            fill="#EBEBEB"
          />
          <path
            d="M266.712 278.785H259.715V278.985H266.712V278.785Z"
            fill="#EBEBEB"
          />
          <path
            d="M334.807 269.119H319.352V269.319H334.807V269.119Z"
            fill="#EBEBEB"
          />
          <path
            d="M77.0233 270.473H42.2422V270.672H77.0233V270.473Z"
            fill="#EBEBEB"
          />
          <path
            d="M89.2934 270.473H84.1953V270.672H89.2934V270.473Z"
            fill="#EBEBEB"
          />
          <path
            d="M181.298 273.871H105.863V274.071H181.298V273.871Z"
            fill="#EBEBEB"
          />
          <path
            d="M190.842 227.726H35.3564C34.1381 227.723 32.9707 227.237 32.1107 226.374C31.2506 225.511 30.7682 224.342 30.7695 223.124V4.55763C30.7798 3.34699 31.2673 2.18927 32.1261 1.33593C32.9849 0.482586 34.1457 0.00252156 35.3564 0H190.842C192.061 -6.82812e-07 193.231 0.484126 194.094 1.34601C194.956 2.2079 195.442 3.37705 195.443 4.59658V223.124C195.443 224.344 194.958 225.515 194.095 226.378C193.232 227.241 192.062 227.726 190.842 227.726ZM35.3564 0.160686C34.1941 0.160686 33.0794 0.622394 32.2576 1.44424C31.4358 2.26609 30.974 3.38075 30.974 4.54302V223.124C30.974 224.286 31.4358 225.401 32.2576 226.223C33.0794 227.045 34.1941 227.506 35.3564 227.506H190.842C192.004 227.506 193.119 227.045 193.94 226.223C194.762 225.401 195.224 224.286 195.224 223.124V4.55763C195.224 3.39536 194.762 2.2807 193.94 1.45885C193.119 0.637003 192.004 0.175294 190.842 0.175294L35.3564 0.160686Z"
            fill="#EBEBEB"
          />
          <path
            d="M365.025 227.726H209.535C208.315 227.723 207.147 227.237 206.284 226.375C205.422 225.513 204.936 224.344 204.934 223.124V4.55763C204.948 3.34565 205.438 2.18796 206.3 1.33501C207.161 0.482072 208.323 0.00247804 209.535 0H365.025C366.235 0.00380145 367.395 0.484431 368.252 1.33764C369.11 2.19085 369.597 3.34783 369.607 4.55763V223.124C369.607 224.341 369.125 225.509 368.266 226.371C367.408 227.233 366.242 227.72 365.025 227.726ZM209.535 0.160686C208.373 0.160686 207.258 0.622394 206.436 1.44424C205.614 2.26609 205.153 3.38075 205.153 4.54302V223.124C205.153 224.286 205.614 225.401 206.436 226.223C207.258 227.045 208.373 227.506 209.535 227.506H365.025C366.187 227.506 367.302 227.045 368.124 226.223C368.946 225.401 369.407 224.286 369.407 223.124V4.55763C369.407 3.39536 368.946 2.2807 368.124 1.45885C367.302 0.637003 366.187 0.175294 365.025 0.175294L209.535 0.160686Z"
            fill="#EBEBEB"
          />
          <path
            d="M175.907 185.908H74.1055V193.09H175.907V185.908Z"
            fill="#EBEBEB"
          />
          <path
            d="M175.907 185.908H131.641V193.09H175.907V185.908Z"
            fill="#E0E0E0"
          />
          <path
            d="M89.1466 193.09H74.1055V263.636H89.1466V193.09Z"
            fill="#EBEBEB"
          />
          <path
            d="M89.1466 200.369L74.1055 195.247V193.09H89.1466V200.369Z"
            fill="#E0E0E0"
          />
          <path
            d="M175.901 193.09H160.859V263.636H175.901V193.09Z"
            fill="#E0E0E0"
          />
          <path
            d="M146.682 193.09H131.641V263.636H146.682V193.09Z"
            fill="#EBEBEB"
          />
          <path
            d="M146.677 200.369L131.641 195.247V193.09H146.677V200.369Z"
            fill="#E0E0E0"
          />
          <path
            d="M118.365 193.09H103.324V263.636H118.365V193.09Z"
            fill="#E0E0E0"
          />
          <path
            d="M185.472 25.9043H57.1719V135.151H185.472V25.9043Z"
            fill="#EBEBEB"
          />
          <path
            d="M186.9 25.8945H185.469V135.141H186.9V25.8945Z"
            fill="#E0E0E0"
          />
          <path
            d="M180.651 30.7246H62.0117V130.311H180.651V30.7246Z"
            fill="#F5F5F5"
          />
          <path
            d="M119.891 115.212C127.141 91.0559 129.142 55.4227 144.563 60.3358C159.984 65.2488 139.791 117.934 139.791 117.934L119.891 115.212Z"
            fill="white"
          />
          <path
            d="M132.342 116.399C124.966 81.3846 126.826 34.9075 103.911 35.969C80.9962 37.0305 103.911 117.919 103.911 117.919L132.342 116.399Z"
            fill="white"
          />
          <path
            d="M148.537 112.471H98.3834C97.359 112.435 96.3618 112.805 95.608 113.499C94.8542 114.194 94.4045 115.158 94.3565 116.181C93.3339 139.291 97.1174 162.887 104.168 185.909H142.587C149.632 162.844 153.416 139.291 152.393 116.181C152.353 115.185 151.929 114.243 151.211 113.551C150.492 112.86 149.534 112.473 148.537 112.471Z"
            fill="#EBEBEB"
          />
          <path
            d="M262.668 38.0879H259.844V263.637H262.668V38.0879Z"
            fill="#E0E0E0"
          />
          <path
            d="M329.094 38.0879H326.27V263.637H329.094V38.0879Z"
            fill="#E0E0E0"
          />
          <path
            d="M242.625 38.0879H239.801V263.637H242.625V38.0879Z"
            fill="#EBEBEB"
          />
          <path
            d="M309.051 38.0879H306.227V263.637H309.051V38.0879Z"
            fill="#EBEBEB"
          />
          <path
            d="M329.093 36.5391H239.801V39.6213H329.093V36.5391Z"
            fill="#EBEBEB"
          />
          <path
            d="M329.093 91.7715H239.801V94.8537H329.093V91.7715Z"
            fill="#EBEBEB"
          />
          <path
            d="M329.093 147.004H239.801V150.086H329.093V147.004Z"
            fill="#EBEBEB"
          />
          <path
            d="M329.093 202.234H239.801V205.317H329.093V202.234Z"
            fill="#EBEBEB"
          />
          <path
            d="M329.093 257.467H239.801V260.549H329.093V257.467Z"
            fill="#EBEBEB"
          />
          <path
            d="M329.093 36.5391H309.051V39.6213H329.093V36.5391Z"
            fill="#E0E0E0"
          />
          <path
            d="M329.093 91.7715H309.051V94.8537H329.093V91.7715Z"
            fill="#E0E0E0"
          />
          <path
            d="M329.093 147.004H309.051V150.086H329.093V147.004Z"
            fill="#E0E0E0"
          />
          <path
            d="M329.093 202.234H309.051V205.317H329.093V202.234Z"
            fill="#E0E0E0"
          />
          <path
            d="M329.093 257.467H309.051V260.549H329.093V257.467Z"
            fill="#E0E0E0"
          />
          <path
            d="M275.82 55.3189V50.9707H265.108V55.3189C265.108 56.6818 264.567 57.989 263.604 58.9531C262.641 59.9173 261.334 60.4596 259.971 60.4609C258.608 60.4609 257.3 61.0018 256.335 61.9649C255.37 62.928 254.827 64.2346 254.824 65.598V91.7848H286.095V65.6077C286.092 64.2444 285.549 62.9378 284.584 61.9746C283.619 61.0115 282.311 60.4706 280.948 60.4706C279.585 60.4668 278.279 59.922 277.318 58.956C276.356 57.99 275.818 56.6818 275.82 55.3189Z"
            fill="#F0F0F0"
          />
          <path
            d="M298.038 129.051H250.996V147.013H298.038V129.051Z"
            fill="#F0F0F0"
          />
          <path
            d="M306.229 129.041H298.039V147.004H306.229V129.041Z"
            fill="#E6E6E6"
          />
          <path
            d="M306.229 137.035H298.039V139.017H306.229V137.035Z"
            fill="#EBEBEB"
          />
          <path
            d="M298.038 137.035H250.996V139.017H298.038V137.035Z"
            fill="#F5F5F5"
          />
          <path
            d="M285.435 225.709H248.691V257.466H285.435V225.709Z"
            fill="#F0F0F0"
          />
          <path
            d="M291.831 225.719H285.438V257.476H291.831V225.719Z"
            fill="#E6E6E6"
          />
          <path
            d="M291.831 239.84H285.438V243.341H291.831V239.84Z"
            fill="#EBEBEB"
          />
          <path
            d="M285.435 239.84H248.691V243.341H285.435V239.84Z"
            fill="#F5F5F5"
          />
          <path
            d="M291.831 236.139H285.438V237.385H291.831V236.139Z"
            fill="#EBEBEB"
          />
          <path
            d="M285.435 236.139H248.691V237.385H285.435V236.139Z"
            fill="#F5F5F5"
          />
          <path
            d="M257.648 169.947H250.996V202.24H257.648V169.947Z"
            fill="#F0F0F0"
          />
          <path
            d="M257.648 181.453H250.996V190.729H257.648V181.453Z"
            fill="#FAFAFA"
          />
          <path
            d="M280.276 169.957H257.648V202.25H280.276V169.957Z"
            fill="#E6E6E6"
          />
          <path
            d="M267.92 165.773H260.406V202.234H267.92V165.773Z"
            fill="#EBEBEB"
          />
          <path
            d="M267.92 177.363H260.406V182.978H267.92V177.363Z"
            fill="#FAFAFA"
          />
          <path
            d="M267.92 186.736H260.406V192.351H267.92V186.736Z"
            fill="#FAFAFA"
          />
          <path
            d="M293.479 165.773H267.93V202.234H293.479V165.773Z"
            fill="#E0E0E0"
          />
          <path
            d="M276.286 169.947H272.234V202.24H276.286V169.947Z"
            fill="#F0F0F0"
          />
          <path
            d="M275.592 174.037H272.934V198.145H275.592V174.037Z"
            fill="#FAFAFA"
          />
          <path
            d="M290.042 169.957H276.281V202.25H290.042V169.957Z"
            fill="#E6E6E6"
          />
          <path
            d="M287.1 168.248H282.527V202.235H287.1V168.248Z"
            fill="#EBEBEB"
          />
          <path
            d="M287.1 179.047H282.527V184.281H287.1V179.047Z"
            fill="#FAFAFA"
          />
          <path
            d="M287.1 187.793H282.527V193.027H287.1V187.793Z"
            fill="#FAFAFA"
          />
          <path
            d="M302.644 168.248H287.102V202.235H302.644V168.248Z"
            fill="#E0E0E0"
          />
          <path
            d="M277.938 129.046C283.47 129.046 287.954 124.561 287.954 119.03C287.954 113.498 283.47 109.014 277.938 109.014C272.406 109.014 267.922 113.498 267.922 119.03C267.922 124.561 272.406 129.046 277.938 129.046Z"
            fill="#F5F5F5"
          />
          <path
            d="M289.026 129.026C292.86 129.026 295.969 125.917 295.969 122.082C295.969 118.247 292.86 115.139 289.026 115.139C285.191 115.139 282.082 118.247 282.082 122.082C282.082 125.917 285.191 129.026 289.026 129.026Z"
            fill="#EBEBEB"
          />
          <path
            d="M201.312 300C287.539 300 357.44 295.919 357.44 290.885C357.44 285.851 287.539 281.77 201.312 281.77C115.084 281.77 45.1836 285.851 45.1836 290.885C45.1836 295.919 115.084 300 201.312 300Z"
            fill="#F5F5F5"
          />
          <path
            d="M101.547 228.441H204.975V281.838C204.975 283.22 204.426 284.545 203.449 285.522C202.472 286.499 201.147 287.048 199.765 287.048H106.762C106.077 287.048 105.399 286.914 104.767 286.653C104.134 286.391 103.559 286.007 103.075 285.524C102.59 285.04 102.206 284.465 101.944 283.833C101.682 283.2 101.547 282.522 101.547 281.838V228.441Z"
            fill="#D1D3D4"
          />
          <path
            d="M101.548 228.442H174.738L165.735 216.916C164.761 215.655 162.297 214.633 160.257 214.633H94.4389C92.4085 214.633 91.5563 215.655 92.5448 216.916L101.548 228.442Z"
            fill="#D1D3D4"
          />
          <path
            opacity="0.2"
            d="M101.548 228.442H174.738L165.735 216.916C164.761 215.655 162.297 214.633 160.257 214.633H94.4389C92.4085 214.633 91.5563 215.655 92.5448 216.916L101.548 228.442Z"
            fill="black"
          />
          <path
            d="M204.978 228.441H131.793L140.796 220.927C141.77 220.119 144.234 219.438 146.274 219.438H212.082C214.118 219.438 214.965 220.105 213.976 220.927L204.978 228.441Z"
            fill="#D1D3D4"
          />
          <path
            opacity="0.2"
            d="M131.793 228.178H204.978V281.559C204.978 282.244 204.843 282.921 204.581 283.553C204.32 284.185 203.936 284.76 203.452 285.244C202.968 285.727 202.394 286.111 201.762 286.373C201.13 286.635 200.452 286.77 199.768 286.77H137.003C136.319 286.77 135.641 286.635 135.009 286.373C134.377 286.111 133.803 285.727 133.319 285.244C132.835 284.76 132.451 284.185 132.19 283.553C131.928 282.921 131.793 282.244 131.793 281.559V228.178Z"
            fill="white"
          />
          <path
            opacity="0.5"
            d="M110.629 228.441V265.063L113.161 263.067L114.938 265.063L116.487 262.838L118.074 265.063L120.28 263.398L122.71 265.063V228.441H110.629Z"
            fill="white"
          />
          <path
            d="M172.698 177.051L215.606 123.431L158.48 75.4688L120.631 118.912L114.997 129.771C114.458 130.366 114.176 131.151 114.214 131.953C114.253 132.755 114.608 133.51 115.202 134.051L115.372 134.192L166.908 177.47C167.748 178.143 168.812 178.473 169.885 178.396C170.959 178.318 171.963 177.838 172.698 177.051Z"
            fill="#D1D3D4"
          />
          <path
            opacity="0.5"
            d="M143.277 137.518L137.098 147.465L139.586 148.006L140.433 150.304L142.084 150.402L142.848 152.374L144.869 152.963L146.422 155.436L152.601 145.493L143.277 137.518Z"
            fill="white"
          />
          <path
            opacity="0.1"
            d="M213.735 121.796L175.258 164.713L120.605 118.83L158.479 75.4062L213.735 121.796Z"
            fill="black"
          />
          <path
            d="M213.735 121.873L175.258 164.791L191.185 165.969L229.068 122.54L213.735 121.873Z"
            fill="#D1D3D4"
          />
          <path
            opacity="0.3"
            d="M213.735 121.873L175.258 164.791L191.185 165.969L229.068 122.54L213.735 121.873Z"
            fill="black"
          />
          <path
            d="M143.158 74.8066L104.676 117.734L120.608 118.912L158.481 75.4835L143.158 74.8066Z"
            fill="#D1D3D4"
          />
          <path
            opacity="0.4"
            d="M143.158 74.8066L104.676 117.734L120.608 118.912L158.481 75.4835L143.158 74.8066Z"
            fill="black"
          />
          <path
            opacity="0.1"
            d="M201.866 135.044L213.713 121.829L158.457 75.4395L151.387 92.477L201.866 135.044Z"
            fill="black"
          />
          <path
            opacity="0.2"
            d="M120.605 118.911L158.479 75.4824L151.408 92.52L124.739 122.378L120.605 118.911Z"
            fill="black"
          />
          <path
            d="M244.988 44.5138C245.344 48.7792 246.395 56.5895 248.918 58.396C248.918 58.396 248.324 63.5234 239.257 64.8381C229.319 66.2988 233.779 60.6018 233.779 60.6018C239.004 58.508 238.274 54.5055 236.774 50.8633L240.606 46.481C242.081 44.84 244.793 42.3275 244.988 44.5138Z"
            fill="#F9B499"
          />
          <path
            d="M252.166 60.4804C252.969 59.7452 251.357 56.8188 250.369 56.4049C247.774 55.319 237.168 56.4049 233.185 59.8133C232.853 60.3793 232.652 61.0126 232.597 61.6666C232.543 62.3206 232.635 62.9786 232.869 63.5919L252.166 60.4804Z"
            fill="#9E77ED"
          />
          <path
            opacity="0.2"
            d="M252.166 60.4804C252.969 59.7452 251.357 56.8188 250.369 56.4049C247.774 55.319 237.168 56.4049 233.185 59.8133C232.853 60.3793 232.652 61.0126 232.597 61.6666C232.543 62.3206 232.635 62.9786 232.869 63.5919L252.166 60.4804Z"
            fill="black"
          />
          <path
            d="M248.162 284.028H241.438L240.766 268.471H247.49L248.162 284.028Z"
            fill="#F9B499"
          />
          <path
            d="M295.387 273.404L289.193 275.536L282.766 260.875L288.959 258.742L295.387 273.404Z"
            fill="#F9B499"
          />
          <path
            d="M287.718 274.003L294.969 271.788C295.096 271.748 295.234 271.754 295.358 271.804C295.482 271.853 295.585 271.944 295.65 272.06L298.674 277.358C298.74 277.471 298.782 277.597 298.798 277.727C298.815 277.856 298.804 277.988 298.769 278.114C298.733 278.24 298.672 278.357 298.589 278.459C298.507 278.561 298.405 278.645 298.289 278.707C298.226 278.746 298.157 278.775 298.085 278.794C295.548 279.525 294.282 279.768 291.112 280.742C289.164 281.336 284.227 283.206 281.447 283.761C278.666 284.316 277.775 281.658 278.856 281.185C283.687 279.048 285.673 276.628 286.818 274.743C287.017 274.395 287.338 274.132 287.718 274.003Z"
            fill="#9E77ED"
          />
          <path
            d="M241.485 283.244H248.819C248.951 283.247 249.08 283.293 249.183 283.376C249.287 283.458 249.361 283.573 249.393 283.702L250.722 289.676C250.751 289.801 250.755 289.931 250.734 290.057C250.712 290.184 250.666 290.305 250.598 290.414C250.529 290.522 250.44 290.616 250.335 290.69C250.231 290.764 250.112 290.817 249.987 290.845C249.91 290.854 249.831 290.854 249.753 290.845C247.105 290.806 243.311 290.645 239.952 290.645C236.056 290.645 234.43 290.86 229.863 290.86C227.111 290.86 226.347 288.074 227.496 287.816C232.755 286.667 235.326 286.545 239.864 283.746C240.349 283.434 240.909 283.26 241.485 283.244Z"
            fill="#9E77ED"
          />
          <path
            d="M261.013 62.6777C262.961 64.4745 264.66 66.2712 266.418 68.1459C268.176 70.0206 269.797 71.9634 271.375 74.0328C273.024 76.1354 274.522 78.3533 275.854 80.6696C276.582 81.9463 277.212 83.2761 277.739 84.6478C277.875 85.0276 278.012 85.388 278.124 85.797C278.256 86.213 278.366 86.6356 278.455 87.063L278.591 87.7301L278.688 88.4702C278.781 89.1488 278.781 89.8367 278.688 90.5153C278.504 91.7976 278.032 93.0214 277.306 94.0942C276.774 94.8762 276.151 95.5922 275.45 96.2269C274.324 97.2481 273.094 98.1474 271.779 98.9099C269.462 100.234 267.038 101.363 264.533 102.284C259.779 104.048 254.88 105.394 249.892 106.306L248.484 101.476C252.867 99.5867 257.283 97.5416 261.368 95.3553C263.359 94.3163 265.275 93.1417 267.104 91.8397C267.864 91.2996 268.562 90.6792 269.188 89.9894C269.384 89.7857 269.548 89.5544 269.675 89.3028C269.744 89.1665 269.675 89.1811 269.597 89.4733C269.539 90.0138 269.549 89.595 269.422 89.3028C269.378 89.1665 269.305 88.9815 269.237 88.8159C269.169 88.6504 269.072 88.4361 268.984 88.2413C268.548 87.3629 268.06 86.5109 267.523 85.6899C266.279 83.8437 264.935 82.067 263.496 80.3678C262.036 78.61 260.453 76.8619 258.851 75.1479C257.249 73.4339 255.564 71.7005 254.021 70.1082L261.013 62.6777Z"
            fill="#F9B499"
          />
          <path
            d="M250.33 100.711L244 102.629L248.076 109.33C248.076 109.33 251.82 107.781 252.648 104.601L250.33 100.711Z"
            fill="#FFC3BD"
          />
          <path
            d="M241.426 105L243.924 110.527L248.024 109.334L243.948 102.629L241.426 105Z"
            fill="#FFC3BD"
          />
          <path
            d="M246.164 64.4991C245.56 70.9411 259.184 80.9134 259.184 80.9134L272.302 71.9344C270.026 67.7269 266.695 64.1831 262.637 61.6506C255.114 56.8495 246.919 56.494 246.164 64.4991Z"
            fill="#9E77ED"
          />
          <path
            d="M223.859 63.982C223.859 63.982 217.972 73.0193 231.952 121.478L267.498 116.229C267.011 111.316 261.056 89.8864 260.856 66.4653C260.839 64.2445 259.942 62.1211 258.36 60.5617C256.779 59.0023 254.643 58.1344 252.422 58.1486C252.296 58.1486 252.169 58.1486 252.047 58.1486C251.015 58.2022 249.954 58.2752 248.897 58.3823C243.827 58.8356 238.787 59.5802 233.802 60.6125C230.406 61.4771 227.082 62.6036 223.859 63.982Z"
            fill="#9E77ED"
          />
          <path
            opacity="0.2"
            d="M222.988 79.5582L223.11 79.4219L231.466 80.1523C232.741 85.5474 228.086 92.9049 225.623 96.3182C224.446 90.7826 223.566 85.1879 222.988 79.5582Z"
            fill="black"
          />
          <path
            d="M244.559 119.618C244.559 119.618 250.329 168.7 254.511 187.928C259.093 208.993 281.711 266.421 281.711 266.421L292.988 262.525C292.988 262.525 278.492 219.282 274.646 189.837C271.69 167.224 267.478 116.229 267.478 116.229L244.559 119.618Z"
            fill="#2F2E41"
          />
          <path
            d="M278.813 262.818C278.76 262.818 281.126 267.648 281.126 267.648L294.273 263.373L292.725 259.443L278.813 262.818Z"
            fill="#2F2E41"
          />
          <path
            opacity="0.3"
            d="M247.742 144.797C249.544 158.431 251.857 174.592 253.882 184.91C256.877 169.099 257.573 149.14 247.742 144.797Z"
            fill="black"
          />
          <path
            d="M231.952 121.478C231.952 121.478 227.166 167.585 227.925 188.075C228.68 209.378 238.638 274.942 238.638 274.942H250.012C250.012 274.942 247.919 210.619 248.401 189.701C248.956 166.889 257.511 117.699 257.511 117.699L231.952 121.478Z"
            fill="#2F2E41"
          />
          <path
            d="M236.428 270.41C236.38 270.41 237.071 275.128 237.071 275.128H250.914L251.289 270.917L236.428 270.41Z"
            fill="#2F2E41"
          />
          <path
            d="M229.746 75.309C228.49 77.3054 227.214 79.0973 225.895 80.9427C224.575 82.7882 223.187 84.5654 221.78 86.3379C218.907 89.931 215.795 93.3261 212.465 96.5C211.56 97.3083 210.732 98.1117 209.758 98.8421L209.047 99.4167L208.697 99.6991C208.565 99.8014 208.511 99.8598 208.244 100.05C207.446 100.62 206.57 101.071 205.643 101.389C204.207 101.879 202.705 102.15 201.188 102.192C199.907 102.237 198.624 102.182 197.351 102.027C192.694 101.414 188.151 100.128 183.863 98.2091L185.256 93.3788C189.376 93.8663 193.525 94.0649 197.673 93.9729C198.59 93.925 199.503 93.8258 200.409 93.6758C201.086 93.5733 201.743 93.3663 202.357 93.0623C202.552 92.9601 202.659 92.8529 202.634 92.8286C202.61 92.8042 202.737 92.7263 202.81 92.6533L203.082 92.4001L203.623 91.9132C204.348 91.2704 205.035 90.4913 205.741 89.7804C207.133 88.2807 208.521 86.7469 209.831 85.1108C211.141 83.4747 212.475 81.8338 213.761 80.1393C215.046 78.4448 216.297 76.7308 217.554 75.0217C218.81 73.3126 220.032 71.5012 221.196 69.8359L229.746 75.309Z"
            fill="#F9B499"
          />
          <path
            d="M234.422 73.1698C237.129 82.027 221.421 91.8434 221.421 91.8434L211.195 78.8425C213.499 74.5501 216.345 70.5717 219.663 67.0053C226.611 59.4483 232.362 66.4308 234.422 73.1698Z"
            fill="#9E77ED"
          />
          <path
            d="M187.621 93.6745L179.344 92.1602L180.215 99.3082C180.215 99.3082 184.515 101.743 187.631 97.9497L187.621 93.6745Z"
            fill="#F9B499"
          />
          <path
            d="M176.164 93.7719L177.951 98.9333L180.206 99.3082L179.334 92.1602L176.164 93.7719Z"
            fill="#F9B499"
          />
          <path
            d="M237.887 54.9935C237.88 54.6146 237.832 54.2377 237.746 53.8687C237.746 53.8687 241.223 53.4889 242.873 51.5996C242.849 51.5996 242.357 54.0245 237.887 54.9935Z"
            fill="#F7A48B"
          />
          <path
            d="M244.111 34.8689C245.572 41.3645 246.785 45.0943 244.52 49.3598C241.112 55.7142 232.376 55.1055 228.987 49.1748C225.934 43.8186 224.021 34.1093 229.528 29.7318C230.735 28.7629 232.169 28.118 233.695 27.8579C235.221 27.5978 236.788 27.7312 238.248 28.2455C239.708 28.7598 241.013 29.6379 242.039 30.7969C243.064 31.9558 243.778 33.3573 244.111 34.8689Z"
            fill="#F9B499"
          />
          <path
            d="M231.07 41.2517L228.597 42.766L228.83 34.3081C227.237 34.3764 225.666 33.9215 224.355 33.0129C225.247 32.1608 239.163 27.2867 243.501 28.1436C243.954 27.9586 244.504 27.1211 244.504 27.1211C244.504 27.1211 244.67 28.1777 243.94 28.5819C244.47 28.4796 245.8 28.7377 246.17 29.5168C245.559 29.3496 244.911 29.3873 244.324 29.6239C244.324 29.6239 249.155 30.3543 247.441 37.0544C245.493 44.4362 246.155 48.6822 246.155 48.6822C246.155 48.6822 242.562 51.4577 239.436 50.9464C236.09 47.2604 231.275 42.8439 231.07 41.2517Z"
            fill="#2F2E41"
          />
          <path
            d="M226.322 32.3474C222.398 32.3474 220.99 30.4289 219.992 28.8172C222.811 28.5202 228.684 26.7088 233.037 26.3826C237.39 26.0563 242.172 26.8695 240.73 28.8172C239.289 30.7649 226.322 32.3474 226.322 32.3474Z"
            fill="#2F2E41"
          />
          <path
            d="M227.175 30.5984C223.952 30.1456 220.811 27.112 223.226 24.2051C224.122 26.3378 230.155 26.0895 234.426 25.1789C240.064 24.0054 243.969 25.9045 241.973 29.7463C240.897 31.8644 227.175 30.5984 227.175 30.5984Z"
            fill="#2F2E41"
          />
          <path
            d="M234.538 39.3288C234.996 40.9188 234.922 42.6147 234.329 44.1591C233.52 46.1799 231.733 45.7708 230.798 44.0228C229.995 42.411 229.381 39.4895 230.75 38.0287C232.118 36.5679 233.954 37.4201 234.538 39.3288Z"
            fill="#F9B499"
          />
        </svg>
      </div>
      <div className="not-found-msg">
          { message }
      </div>
    </section>
  </>
  )
};

export default NotFoundComponent;
